import { SetListenerIfc } from '../SetListenerIfc';
import { RecShapeIfc } from '../../shape/RecShapeIfc';
import { BitBoardBitSetForNext32 } from './manager32/BitBoardBitSetForNext32';
import { AbstractContainer } from '../operator/AbstractContainer';
import { BitBoardEntity } from '../../utils/BitBoardEntity';
import { ConcreteContainer } from './ConcreteContainer';

export class IdBufferListener implements SetListenerIfc{
    adds:BitBoardBitSetForNext32;
    deletes:BitBoardBitSetForNext32;
    res:boolean;
    updates:Map<number, BitBoardEntity>;
    updateSize:number = 0;
    
    dispatcher:SetListenerIfc;
    containerSet:AbstractContainer;
    
    shape:RecShapeIfc;
    underShape:RecShapeIfc;
    
    beCount:number = 0;
    
    metas:Map<string, string>;
    metasSize:number = 0;
    
    metasToRemove:Map<string, string>;
    metasToRemoveSize:number = 0;
    
    isSetListener():boolean{
        return true;
    }
    constructor( underShape:RecShapeIfc, shape:RecShapeIfc, dispatcher:SetListenerIfc, container:AbstractContainer = null ) 
    {
        this.shape = shape;
        this.underShape = underShape;
        this.dispatcher = dispatcher;
        if( container == null) {
            this.containerSet = new ConcreteContainer( shape );
        }else{
            this.containerSet = container;
        }
    
        this.metas = new Map();
        this.metasSize = 0;
        this.metasToRemove = new Map();
        this.metasToRemoveSize = 0;
        
        this.adds = new BitBoardBitSetForNext32();
        this.deletes = new BitBoardBitSetForNext32();
        this.res = false;
        this.updates = new Map<number, BitBoardEntity>();
        this.updateSize = 0;
    }
    
public setContainerMetaData( name:string, value:string ):void {
    if( this.metasToRemove.has( name ) ){
        this.metasToRemoveSize--;
        this.metasToRemove.delete(name);
    }
    this.metas.set( name, value );
    this.metasSize++;
}
public removeContainerMetaDatas( names:Array<string>):void {
    for(let i:number = 0; i < names.length; i++ ){
        let meta:string = names[ i ];
        if( this.metas.has( meta ) ){
            this.metas.delete( meta );
            this.metasSize--;
        }
        this.metasToRemove.set( meta, meta );
        this.metasToRemoveSize++;
    }
}
public removeMetaData( name:string ):void {
    if( this.metas.has(name) ){
        this.metas.delete( name );
        this.metasSize--;
    }
    this.metasToRemove.set( name, name );
    this.metasToRemoveSize++;
}
public setContainerMetaDatas( names:Array<string>, values:Array<string>):void {
    for( let i:number = 0; i < names.length; i++ ){
        this.metas.set( names[ i ], values[ i ] );
        this.metasSize++;
        if ( this.metasToRemove.has(names[ i ]) ) {
            this.metasToRemove.delete( names[ i ] );
            this.metasToRemoveSize--;
        }
    }
}

    public begin():void {
        this.beCount++;
    }
    public end():void {
        this.beCount--;
        if( this.beCount < 0 ){
            throw new Error("Be count below zero!");
        }
        if( this.beCount == 0 && this.shape == this.underShape){
            this.flush();
        }
    }
    
    public addRecord( recordId:number ):void {
        this.containerSet.put(recordId);
        if( this.shape != this.underShape ) {
            //WriteRecordUtil.rewriteRecord(underShape, shape, 
                //	shape.getCellsAsBitBoard(), recordId, recordId);
        }
        this.adds.allocateConcrete(recordId);		
    }
    
    public addRecords( records:Array<number> ):void {
        for (  let recordId of records ){
            this.addRecord(recordId);
        }
    }
    
    public deleteRecord( id:number ):void {
        this.containerSet.removeRecord(id);
        if ( this.adds.isAllocated( id ) ){
            this.adds.free(id);
            if( this.updates.has(id) ){
                this.updateSize--;
                this.updates.delete( id );
            }
        }else {
            if( !this.deletes.isAllocated( id ) ) {
                this.deletes.allocateConcrete(id)	
            }
            if ( this.updates.has( id ) ) {
                this.updateSize--;	
                this.updates.delete( id );
            }
        }
    }
    public deleteRecords( ids:Array<number> ):void {
        for ( let id of ids ){
            this.deleteRecord(id);
        }
    }
    public cellsUpdated( colls:BitBoardEntity, id:number ):void {
        this.containerSet.assertContains(id);
        if( this.shape != this.underShape ){
            //WriteRecordUtil.rewriteRecord( underShape, shape, colls, id, id);
        }
        if( !this.adds.isAllocated(id)){
            let bufferedCells:BitBoardEntity = !this.updates.has( id ) ? null : this.updates.get( id );
            if ( bufferedCells != null ) {
                this.updates.delete( id );
                bufferedCells.add(colls);
            }else {
                this.updateSize++;
                bufferedCells = colls.clone();
            }
            this.updates.set( id, bufferedCells );
        }
    }

    public reset():void {
        this.containerSet.reset();
        this.res = true;
        this.adds.reset();
        this.deletes.reset();
        this.updates = new Map<number, BitBoardEntity>();
        this.updateSize = 0;
    }
    
    public flush():void{
        if( this.res || this.adds.size() > 0 || this.deletes.size() > 0 || this.updateSize > 0 || this.metasSize > 0 || this.metasToRemoveSize > 0 ){
            this.dispatcher.begin();

            if( this.res ){
                this.dispatcher.reset();
            }


            if( this.deletes.size() > 0 && this.adds.size() > 0){
                let dels = this.deletes.nextSetBit(0);
                let ads = this.adds.nextSetBit(0);
            }
            if( this.deletes.size() > 0 ){
                if( this.deletes.size() > 1 ){
                    this.dispatcher.deleteRecords( this.deletes.toArray()  );
                }else{
                    this.dispatcher.deleteRecord( this.deletes.nextSetBit( 0 )  );
                }
            }

            if ( this.updateSize > 0 ) {
                this.updates.forEach( (val:BitBoardEntity, key:number, map:Map<number, BitBoardEntity> ) => {
                    let id:number = key;
                    this.dispatcher.cellsUpdated( val, key);
                });
            }

            if ( this.metasSize > 0 ) {
                if ( this.metasSize > 1 ) {
                    let names:Array<string> = new Array();
                    let values:Array<string> = new Array();
                    let k:number = 0;

                    this.metas.forEach( (val:string, key:string, map:Map<string, string>) => {
                        names[ k ] = key;
                        values[ k ] = val;
                        k++;
                    });
                    this.dispatcher.setContainerMetaDatas( names, values );
                }else {
                    this.metas.forEach( (val:string, key:string, map:Map<string, string>) => {
                        this.dispatcher.setContainerMetaData( key, val );
                    });
                }
            }
            
            if ( this.metasToRemoveSize > 0 ) {
                if ( this.metasToRemoveSize > 1 ) {
                    let names:Array<string> = new Array();
                    let k:number = 0;

                    this.metasToRemove.forEach( (val:string, key:string, map:Map<string, string>) => {
                        names[ k ] = key;
                        k++;
                    });
                    this.dispatcher.removeContainerMetaDatas( names );
                }else {
                    this.metasToRemove.forEach( (val:string, key:string, map:Map<string, string>) => {
                        this.dispatcher.removeMetaData( key );
                    });
                }
            }
            
            if( this.adds.size() > 0 ){
                if( this.adds.size() > 1){
                    let records:Array<number> = new Array() ;
                    let j:number = 0;
                    for ( let i:number = this.adds.nextSetBit( 0 ); i >= 0; i = this.adds.nextSetBit( i + 1)) {
                        records[ j++ ] = i;
                    }
                    this.dispatcher.addRecords(records);
                }else{
                    this.dispatcher.addRecord(this.adds.nextSetBit( 0 ) );
                }
            }

            this.dispatcher.end();
        }
        this.res = false;
        this.adds.reset();
        this.deletes.reset();
        this.updates = new Map<number, BitBoardEntity>();
        this.updateSize = 0;
        this.metasSize = 0;
        this.metas = new Map();
        this.metasToRemoveSize = 0;
        this.metasToRemove = new Map();
    }
}